export const TENANT_USER_TYPE_OPTIONS = [
  { value: "sp_manager", label: "SP Manager", group: "manager" },
  { value: "hr_officer", label: "HR Officer", group: "manager" },
  { value: "sp_standard_user", label: "Standard User", group: "worker" },
  { value: "sp_cos", label: "Support Coordinator", group: "worker" },
];

export const MANAGER_USER_TYPES = ["sp_manager", "hr_officer"];
export const WORKER_USER_TYPES = ["sp_standard_user", "sp_cos"];

export const formatUserTypeLabel = (userType) => {
  const match = TENANT_USER_TYPE_OPTIONS.find((option) => option.value === userType);
  if (match) {
    return match.label;
  }

  if (userType === "sp_admin") {
    return "SP Admin";
  }

  return userType || "—";
};

export const buildOwnerUserRow = (tenant) => {
  if (!tenant?.owner?.id) {
    return null;
  }

  return {
    id: tenant.owner.id,
    name: tenant.owner.name,
    email: tenant.owner.email,
    user_type: "sp_admin",
    status: true,
    isOwner: true,
  };
};

export const mergeTenantUsers = (ownerRow, createdUsers = []) => {
  const rows = [];
  const seen = new Set();

  if (ownerRow) {
    rows.push(ownerRow);
    seen.add(ownerRow.id);
  }

  createdUsers.forEach((user) => {
    if (!user?.id || seen.has(user.id)) {
      return;
    }

    rows.push(user);
    seen.add(user.id);
  });

  return rows;
};

export const isActionReasonValid = (reason) =>
  typeof reason === "string" && reason.trim().length >= 10;

export const getReadOnlyAction = (tenant) => ({
  enabled: !tenant?.flags?.read_only,
  title: tenant?.flags?.read_only ? "Lift read-only mode" : "Set read-only mode",
  description: tenant?.flags?.read_only
    ? "Allow write access for this tenant again."
    : "Restrict this tenant to read-only access.",
});

export const getWildcardAction = (tenant) => ({
  enabled: !tenant?.flags?.wildcard,
  title: tenant?.flags?.wildcard ? "Remove wildcard access" : "Enable wildcard access",
  description: tenant?.flags?.wildcard
    ? "Remove commercial wildcard concessions for this tenant."
    : "Grant wildcard access for this tenant.",
});
